// Types propres à l'appareil de l'application terrain. Depuis le raccordement du lot L3, tous les types
// échangés avec le serveur viennent de @cc/contrats (terrain.ts, interventions.ts, proprete.ts,
// inspections.ts) ; ne restent ici que la position relevée par l'appareil (avec sa précision et son
// heure), l'envoi d'une photo (fichier en Blob) et le travail réuni sur l'appareil après pagination.
import type { MissionTerrain, ObjetPhotoTerrain, OrdreMissionTerrain, TourneeTerrain, TravailTerrain } from '@cc/contrats';

/** Position WGS84 relevée par l'appareil (longitude puis latitude, précision en mètres). */
export interface PositionTerrain {
  longitude: number;
  latitude: number;
  precision_m: number | null;
  horodatage: string;
}

/** Position telle que le contrat l'attend (schemaPosition : longitude et latitude seulement). */
export function positionContrat(p: PositionTerrain | null | undefined): { longitude: number; latitude: number } | undefined {
  return p ? { longitude: p.longitude, latitude: p.latitude } : undefined;
}

/** Photo à envoyer par POST /terrain/photos (champs du contrat schemaPhotoTerrain et fichier). */
export interface EnvoiPhoto {
  id_client: string;
  objet_type: ObjetPhotoTerrain;
  objet_id_client: string;
  empreinte_sha256: string;
  fichier: Blob;
  nom: string;
}

/** Travail réuni sur l'appareil : toutes les pages de GET /terrain/travail mises bout à bout. */
export interface TravailAppareil {
  horodatage: string;
  agent: TravailTerrain['agent'] | null;
  missions: MissionTerrain[];
  tournees: TourneeTerrain[];
  ordres_mission: OrdreMissionTerrain[];
  referentiels: TravailTerrain['referentiels'];
}
